import {
  Twitter,
  Facebook,
  Instagram,
  Music,
  Linkedin,
  Youtube,
  MessageCircle,
  Gamepad2,
  Hash,
  Star,
  MapPin,
  Pin,
  Video,
  Palette,
  Cloud,
} from 'lucide-react'

export interface SocialPlatform {
  id: string
  name: string
  icon: any
  color: string
  description: string
  isConnectable: boolean
  category: 'social' | 'professional' | 'entertainment' | 'messaging' | 'reviews'
}

// Only Reddit, Bluesky, and YouTube are connectable. Other entries are kept
// (with isConnectable: false) so legacy components that look up platform metadata
// by id during the narrow-scope cleanup don't crash.
export const SOCIAL_PLATFORMS: SocialPlatform[] = [
  {
    id: 'reddit',
    name: 'Reddit',
    icon: MessageCircle,
    color: '#FF4500',
    description: 'Connect your Reddit account to fetch your feed',
    isConnectable: true,
    category: 'social',
  },
  {
    id: 'bluesky',
    name: 'Bluesky',
    icon: Cloud,
    color: '#0085FF',
    description: 'Connect with a Bluesky app password',
    isConnectable: true,
    category: 'social',
  },
  {
    id: 'youtube',
    name: 'YouTube',
    icon: Youtube,
    color: '#FF0000',
    description: 'Read-only access to your YouTube channel',
    isConnectable: true,
    category: 'entertainment',
  },
  {
    id: 'twitter',
    name: 'X (Twitter)',
    icon: Twitter,
    color: '#000000',
    description: 'Connect X to bring your home timeline into your curated feed.',
    isConnectable: true,
    category: 'social',
  },
  { id: 'facebook', name: 'Facebook', icon: Facebook, color: '#1877F2', description: 'Pages, posts, and audience signal', isConnectable: false, category: 'social' },
  { id: 'instagram', name: 'Instagram', icon: Instagram, color: '#E4405F', description: 'Photos, stories, and Reels', isConnectable: false, category: 'social' },
  { id: 'tiktok', name: 'TikTok', icon: Music, color: '#FF0050', description: 'Short-form video and trends', isConnectable: false, category: 'entertainment' },
  { id: 'threads', name: 'Threads', icon: Hash, color: '#000000', description: 'Text-based conversations from Meta', isConnectable: false, category: 'social' },
  { id: 'linkedin', name: 'LinkedIn', icon: Linkedin, color: '#0A66C2', description: 'Professional networking', isConnectable: false, category: 'professional' },
  { id: 'whatsapp', name: 'WhatsApp', icon: MessageCircle, color: '#25D366', description: 'WhatsApp Business messaging', isConnectable: false, category: 'messaging' },
  { id: 'discord', name: 'Discord', icon: Gamepad2, color: '#5865F2', description: 'Communities and gaming chat', isConnectable: false, category: 'messaging' },
  { id: 'google_reviews', name: 'Google Reviews', icon: Star, color: '#4285F4', description: 'Google Business reviews and ratings', isConnectable: false, category: 'reviews' },
  { id: 'yelp_reviews', name: 'Yelp Reviews', icon: MapPin, color: '#FF1A1A', description: 'Yelp business reviews and ratings', isConnectable: false, category: 'reviews' },
  { id: 'twitch', name: 'Twitch', icon: Video, color: '#9146FF', description: 'Live streaming', isConnectable: false, category: 'entertainment' },
  { id: 'pinterest', name: 'Pinterest', icon: Pin, color: '#BD081C', description: 'Visual discovery', isConnectable: false, category: 'social' },
  { id: 'tumblr', name: 'Tumblr', icon: Palette, color: '#001935', description: 'Microblogging', isConnectable: false, category: 'social' },
  { id: 'wechat', name: 'WeChat', icon: MessageCircle, color: '#07C160', description: 'Chinese messaging and social', isConnectable: false, category: 'messaging' },
]

export function getPlatformById(id: string): SocialPlatform | undefined {
  return SOCIAL_PLATFORMS.find(p => p.id === id)
}

export function getConnectablePlatforms(): SocialPlatform[] {
  return SOCIAL_PLATFORMS.filter(p => p.isConnectable)
}

export function getPlatformsByCategory(category: SocialPlatform['category']): SocialPlatform[] {
  return SOCIAL_PLATFORMS.filter(p => p.category === category)
}
